// extracted by mini-css-extract-plugin
module.exports = {"SearchWindow":"SearchWindow_SearchWindow_1BTYe","FormTitle":"SearchWindow_FormTitle_3-Smo","Message":"SearchWindow_Message_3ce-i"};